<div *ngIf="data" class="alert alert-info mt-10">This {{data['type']}} is assigned to <a class="btn-link"
    [routerLink]="['/team',data['reviewer']['login']]">{{reviewerName}}</a>
  for review
  <span i18n-ngbTooltip ngbTooltip="Delete" (click)="onDelete()" container="body" class="ml-10 cursor-pointer"><i
      class="fas fa-trash-alt"></i></span>
</div>
